import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import transformToOption from "../utils/transformToOptionSelect";
import { getAppRoles } from "../services/userServices";

export function useUserRoles() {
  const roles = useQuery({
    queryKey: ["userRoles"],
    queryFn: () => getAppRoles(),
    staleTime: FIVE_MINUTES_IN_MS,
  });

  return {
    roles: roles.data || null,
    roleOptions: roles.data ? transformToOption(roles.data) : null,
    isLoadingRoles: roles.isLoading,
  };
}
